import {AwsrdsInstanceTarget, getByOrgIdTargetsAndAccountIdRegionRdsInstance} from "../../api/api";
import {ITargetSetEditActions} from "../../pages/EditTargetSetPage";
import {useContext} from "react";
import {OrgContext} from "../../services/OrgContext";
import {useAuthQuery} from "../../api/apiCall";
import {Alert, Container, Header, SpaceBetween, TokenGroup} from "@cloudscape-design/components";
import {describeTagFilters} from "../../utilities/targetSets";
import {GenericSelectByTagOrIdTable} from "./GenericSelectByTagOrIdTable";
import {ErrorBox} from "../ErrorBox";
import {retryText} from "../../utilities/utils";

export function RDSInstanceTargets(props: {
    accountId: string,
    region: string,
    targets: AwsrdsInstanceTarget[],
    actions: ITargetSetEditActions,
}) {
    const orgContext = useContext(OrgContext);
    const {
        isPending,
        data,
        isError,
        error,
        failureCount
    } = useAuthQuery(getByOrgIdTargetsAndAccountIdRegionRdsInstance, props.region, orgContext.Organization!.id!, props.accountId, {})

    return <SpaceBetween size={"m"}>
        <Container header={<Header variant={"h3"}>Selected RDS Instances</Header>}>
            <TokenGroup
                onDismiss={x => props.actions.removeTarget(props.targets[x.detail.itemIndex])}
                items={props.targets.map(t => ({
                    label: !!t.instanceId ? `Instance` : "Tag Filter",
                    description: !!t.instanceId
                        ? `Specific instance with ARN ${t.instanceId}`
                        : `Any instance that matches specified tags`,
                    iconName: !!t.instanceId ? "heart": "expand",
                    tags: describeTagFilters(t.tagFilters ?? [])
                }))}
            />
        </Container>
        {!isError
            ? <GenericSelectByTagOrIdTable
                data={data ?? []}
                targets={props.targets}
                targetIdentifier={"instanceId"}
                targetIdentifierName={"Instance ARN"}
                actions={props.actions}
                table={{
                    loading: isPending,
                    loadingText: `Retrieving RDS Instances... ${retryText(failureCount)}`,
                    columnDefinitions: [
                        {
                            id: "desc",
                            header: "Description",
                            cell: item => item.detail!.description
                        }
                    ]
                }} />
            : <ErrorBox attempted={"List RDS Instances"} error={error} />
        }
    </SpaceBetween>
}